$(document).ready(function(){
// var cart_drawer_count = $(".js-menu__context span.cart-item-count").text();
// $(".cart-count-bubble span.header-cart-item").text("0"); 


   jQuery.getJSON('/cart.js', function(cart) {
                if(cart.item_count != 0){
$(".cart-count-bubble").removeClass("cart-item-zero");
                  
                  // $(".cart-count-bubble").css("display", "block");
                } else{
                  $(".cart-count-bubble").addClass("cart-item-zero");
                }
});


	$('.js-menu__open').click(function(){
		$.ajax({
			url : '/cart?view=sidecart',
			dataType : 'HTML',
			method : "GET",
			success : function(htmlData) {
				let html_markup = $(htmlData);
				let to_replace = $(htmlData).html();
				$("#shopify-section-header").find('div.js-menu__context').html(to_replace);
				$('.js-menu__context').addClass('js-menu__expanded');
              $('.js-menu--right').addClass('js-menu__expanded');
              $("body").addClass("popup");

              jQuery.getJSON('/cart.js', function(cart) {
              var cart_drawer_count = $(".js-menu__context span.cart-item-count").text();
                if(cart.item_count != 0){
              $(".cart-count-bubble span.header-cart-item").text(cart_drawer_count); 
              $(".cart-count-bubble").removeClass("cart-item-zero");
              $(".js-menu__context").removeClass("cart-zero-opacity");
              $(".cart-count-bubble").show();
              } else{
              $(".cart-count-bubble span.header-cart-item").text("0");
              $(".cart-count-bubble").addClass("cart-item-zero");
              $(".js-menu__context").addClass("cart-zero-opacity");
              $(".cart-count-bubble").hide();
              }
            });
              
             console.log("header cart icon clicked");
			}
		})
    });

	$('.qty-input span').click(function() {
		val = parseInt($(this).parent().find('input').val());
	  
		if ($(this).hasClass('minus')) {
			val = val - 1;
		} else if ($(this).hasClass('plus')) {
			val = val + 1;
		}
	  
		if (val < 1) {
			val = 1;
		}
	  
		$(this).parent().find('input').val(val);
     
	  });
});


$(document).ready(function(){
// quantity update js start
	function refreshCart(){
		$.ajax({
			url : '/cart?view=sidecart',
			dataType : 'HTML',
			method : "GET",
			success : function(htmlData) {
				let html_markup = $(htmlData);
				let to_replace = $(htmlData).html();
				// $("#shopify-section-header").find('.js-menu__context').html(to_replace);
				$("#shopify-section-header").find('.js-menu--right').html(to_replace);
				$('.js-menu__context').addClass('js-menu__expanded');
              $("body").addClass("popup");
              $('.js-menu--right').addClass('js-menu__expanded');
             jQuery.getJSON('/cart.js', function(cart) {
              var cart_drawer_count = $(".js-menu__context span.cart-item-count").text();
                if(cart.item_count != 0){
$(".cart-count-bubble span.header-cart-item").text(cart_drawer_count); 
                  $(".cart-count-bubble").removeClass("cart-item-zero");
                  $(".js-menu__context").removeClass("cart-zero-opacity");
                  $(".cart-count-bubble").show();
                } else{
                  $(".cart-count-bubble span.header-cart-item").text("0");
                  $(".cart-count-bubble").addClass("cart-item-zero");
                  $(".js-menu__context").addClass("cart-zero-opacity");
                  $(".cart-count-bubble").hide();
                }
});
			}
		})
  	}

	function refreshCartItemsOnly(){
		$.ajax({
			url : '/cart?view=sidecart',
			dataType : 'HTML',
			method : "GET",
			success : function(htmlData) {
				let html_markup = $(htmlData);
				let to_replace = $(htmlData).html();
				// $("#shopify-section-header").find('.js-menu--right').html(to_replace);

			  $("#shopify-section-header").find('.cart-drawer-header').html(html_markup.find('.cart-drawer-header').html());
			  $("#shopify-section-header").find('.shopping-cart-items').html(html_markup.find('.shopping-cart-items').html());

			  $('.js-menu__context').addClass('js-menu__expanded');
              $("body").addClass("popup");
              $('.js-menu--right').addClass('js-menu__expanded');

             jQuery.getJSON('/cart.js', function(cart) {
              var cart_drawer_count = $(".js-menu__context span.cart-item-count").text();
                if(cart.item_count != 0){
				  $(".cart-count-bubble span.header-cart-item").text(cart_drawer_count); 
                  $(".cart-count-bubble").removeClass("cart-item-zero");
                  $(".js-menu__context").removeClass("cart-zero-opacity");
                  $(".cart-count-bubble").show();
                } else{
                  $(".cart-count-bubble span.header-cart-item").text("0");
                  $(".cart-count-bubble").addClass("cart-item-zero");
                  $(".js-menu__context").addClass("cart-zero-opacity");
                  $(".cart-count-bubble").hide();
                }
			});
			}
		})
  	}


	$(document).on('click','.js-menu__close, .js-menu__context .product-showcase, .js-menu .continue-shopping a',function(){
        $('.js-menu__context').removeClass('js-menu__expanded');
              $('.js-menu--right').removeClass('js-menu__expanded');
      $("body").removeClass("popup");
    });

	$(document).on('click','span.plus',function(e){
		let parent = $(e.target).parents('.qty-input').eq(0);
		let current_qty = $(parent).attr('data-quantity');
		let updated_qty = parseInt(current_qty) + 1;
		let current_item = {};		
		let key = $(parent).attr('data-key');
		current_item[key] = updated_qty;
		$.ajax({
			url: "/cart/update.js",
			data: { 'updates': current_item },
			method: "POST",
			dataType: "JSON",
			success: function (data) {
			$.get('/cart.json', function (cart) {
				console.log('got here called');
				// refreshCart();
				refreshCartItemsOnly();
			});
			}, error: function (error) {
				console.log(error)
			}
		});
	});

	$(document).on('click','span.minus',function(e){
		let parent = $(e.target).parents('.qty-input').eq(0);
		let current_qty = $(parent).attr('data-quantity');
		let updated_qty = parseInt(current_qty) - 1;
		let current_item = {};
		if (updated_qty < 1) {
			updated_qty = 1;
		}
		let key = $(parent).attr('data-key');
		current_item[key] = updated_qty;
		$.ajax({
			url: "/cart/update.js",
			data: { 'updates': current_item },
			method: "POST",
			dataType: "JSON",
			success: function (data) {
			$.get('/cart.json', function (cart) {
				console.log('got here called');
				// refreshCart();
				refreshCartItemsOnly();
				
			});
			}, error: function (error) {
				console.log(error)
			}
		});
	});
// quantity update js end

// drawer remove button start
  	$(document).on('click','.remove',function(e){
       $(this).find('.loading-overlay__spinner').show();
        // alert("hey");
      });
	$(document).on('click','.remove-cart-product',function(e){
       
		e.preventDefault();
		let current_em = $(e.target);
		let key = $(current_em).attr('data-key');
		let updated_qty = 0;
		let current_item = {};
		current_item[key] = updated_qty;
		$.ajax({
			url: "/cart/update.js",
			data: { 'updates': current_item },
			method: "POST",
			dataType: "JSON",
			success: function (data) {
			$.get('/cart.json', function (cart) {
				console.log('got here called');
				// refreshCart();	
				refreshCartItemsOnly();
			});
			}, error: function (error) {
				console.log(error)
			}
		});
	})
   // drawer remove button end 
// pdp form data to drawer js start
 $('.product-form .form').submit(function() { 
   $formData = $('.product-form .form').serialize();
   if (window.location.href.indexOf("custom") > -1) {
        $('.product__info-container').css('opacity', 0.5);
        $('.atc-loader').css('display', 'block');
        $('#personalize3D').attr('disabled','disabled');
        $('.product-form__submit').attr('disabled','disabled');
      setTimeout(() => {
        $('.product__info-container').css('opacity', 1);
        $('.atc-loader').css('display', 'none');
        $('#personalize3D').attr('disabled',false);
        $('.product-form__submit').attr('disabled',false);
      }, 2500);
      setTimeout(()=> {
        	refreshCart()
      }, 2500);
   }else{
     $.ajax({
      url: '/cart/add.js',
      type: 'post',
      dataType: 'json',
      data: $formData,
      success: function(data) { 
        setTimeout(()=> {
        	refreshCart()
        }, 500);
      }
    });
   }
   return false;
  });
  
  // $('.product-main-section-wrapper form').submit(function() {
  //   $.ajax({
  //     url: '/cart/add.js',
  //     type: 'post',
  //     dataType: 'json',
  //     data: $('.product-main-section-wrapper form').serialize(),
  //     success: function(data) { 
  //       refreshCart();
  //     }
  //   });
  //   return false;
  // });
// pdp form data to drawer js end
  });

//   jQuery(document).ready(function() {
//   jQuery("#addToCart, .js-menu__close").click(function() {
//     setTimeout(function() {
//       jQuery.getJSON('/cart.js', function(cart) {
//           console.log(cart);
//           jQuery("span.new-cart-count").html(cart.item_count);
//        });
//      }, 200);
//   });
// });
